function shouldRedirectToExternalModule({ input, output }) {
  if (input.result.redirect && input.result.agreedGDPRTermsAt) {
    output.true()
  } else {
    output.false()
  }
}

shouldRedirectToExternalModule.outputs = ['true', 'false']
export default shouldRedirectToExternalModule



// WEBPACK FOOTER //
// ./src/modules/login/actions/shouldRedirectToExternalModule.js